<template>
<div class="Order" 
    v-loading.fullscreen.lock="submitLoading"
    element-loading-text="审核提交中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <!-- 导航栏 -->
    <div class="OrderTop">
        <div class="Nav">
            <div class="NavItem" :class="{ Act: i == 1 }" @click="ToggleNav(1)">学术审核</div>
            <div class="NavItem" :class="{ Act: i == 2 }" @click="ToggleNav(2)">专家复评</div>
        </div>
    </div>

    <!-- 状态筛选栏 -->
    <div class="OrderTop" v-if="i == 1">
        <div class="Nav">
            <div class="NavItem" :class="{ Act: academicSearch.checkStatus == '-1' }" @click="academicSearch.checkStatus = '-1'; Query('academic')">全部</div>
            <div class="NavItem" :class="{ Act: academicSearch.checkStatus == '0' }" @click="academicSearch.checkStatus = '0'; Query('academic')">待审核</div>
            <div class="NavItem" :class="{ Act: academicSearch.checkStatus == '1' }" @click="academicSearch.checkStatus = '1'; Query('academic')">审核通过</div>
            <div class="NavItem" :class="{ Act: academicSearch.checkStatus == '2' }" @click="academicSearch.checkStatus = '2'; Query('academic')">审核不通过</div>
        </div>
    </div>
    
    <!-- 刷新按钮 - 独立于导航栏 -->
    <div class="refresh-container" v-if="i == 1">
        <el-button 
            type="primary" 
            size="small" 
            icon="el-icon-refresh" 
            @click="refreshAcademicList" 
            :loading="refreshLoading"
            class="refresh-button">
            刷新列表
        </el-button>
    </div>
    <div class="OrderTop" v-if="i == 2">
        <div class="Nav">
            <div class="NavItem" :class="{ Act: expertSearch.checkStatus == '-1' }" @click="expertSearch.checkStatus = '-1'; Query('expert')">全部</div>
            <div class="NavItem" :class="{ Act: expertSearch.checkStatus == '0' }" @click="expertSearch.checkStatus = '0'; Query('expert')">待审核</div>
            <div class="NavItem" :class="{ Act: expertSearch.checkStatus == '1' }" @click="expertSearch.checkStatus = '1'; Query('expert')">审核通过</div>
            <div class="NavItem" :class="{ Act: expertSearch.checkStatus == '2' }" @click="expertSearch.checkStatus = '2'; Query('expert')">审核不通过</div>
        </div>
    </div>

    <div class="table-container">
        <el-table 
            :data="tableData" 
            style="width: 100%" 
            border
            class="no-wrap-table">
            <el-table-column type="selection" align="center" />
            <!-- <el-table-column cell-class-name="custom-text-size" prop="id" label="ID"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="userName" label="姓名"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="userPhone" label="电话"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="userUnitLevel" label="单位等级"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="userZhicheng" label="职称"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="userEmail" label="邮箱"></el-table-column> -->
            <el-table-column cell-class-name="custom-text-size" prop="projectCode" label="项目编号"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="projectCase" label="项目主题"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="worksType" label="内容形式"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="worksName" label="作品名称"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" label="状态" v-if="i === 1">
                <template slot-scope="scope">
                    {{ scope.row.statusText }}
                </template>
            </el-table-column>
            <el-table-column cell-class-name="custom-text-size" label="总分" v-if="i === 2">
                <template slot-scope="scope">
                    {{ getExpertScore(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column cell-class-name="custom-text-size" label="操作" fixed="right" width="200">
                <template slot-scope="scope">
                    <el-button 
                        class="ColorBlue" 
                        size="mini" 
                        @click="handleView(scope.row)">
                        查看
                    </el-button>
                    <el-button 
                        class="ColorBlue" 
                        size="mini" 
                        @click="handleScore(scope.row)"
                        v-if="i === 2 && !hasExpertApproved(scope.row)">
                        打分
                    </el-button>
                    <el-button 
                        class="ColorBlue" 
                        size="mini" 
                        @click="handleModifyScore(scope.row)"
                        v-if="i === 2 && hasExpertApproved(scope.row) && scope.row.isXiugai !== 1">
                        修改
                    </el-button>
                    <el-button 
                        class="ColorBlue" 
                        size="mini" 
                        @click="handleScore(scope.row)"
                        v-if="i === 1 && scope.row.checkStatus === 0">
                        审核
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="PageDis">
        <el-pagination 
            background 
            :page-sizes="[10, 20, 50]" 
            layout="prev,pager,next,total,sizes"  
            @size-change="handleSizeChange" 
            @current-change="handleCurrentChange" 
            :total="total" 
            :current-page="pageNum" 
            :hide-on-single-page="false">
        </el-pagination>
    </div>

    <!-- 查看详情弹窗 -->
    <el-dialog title="作品详情" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
        <div class="detail-content">
            <div class="section-title">专业信息</div>
            <div class="detail-grid">
                <div class="detail-item">
                    <span class="label">项目编号：</span>
                    <span class="value">{{viewForm.projectCode}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">作品名称：</span>
                    <span class="value">{{viewForm.worksName}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">项目主题：</span>
                    <span class="value">{{viewForm.projectCase}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">创作时间：</span>
                    <span class="value">{{viewForm.workTime || ''}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">作品成绩：</span>
                    <span class="value">{{viewForm.isGood === 1 ? '优秀' : '一般'}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">内容形式：</span>
                    <span class="value">{{viewForm.worksType}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">作品状态：</span>
                    <span class="value">{{viewForm.statusText}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">备注：</span>
                    <span class="value">{{viewForm.des || '-'}}</span>
            </div>

                <!-- 根据内容形式显示相应的文件 -->
                <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普文章') || viewForm.rawWorksType === '1')" class="detail-item">
                    <span class="label">科普文章：</span>
                    <div class="file-item">
                        <img src="../../assets/applyRey/word.png" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewFile('科普文章')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadFile('科普文章')">下载</el-button>
                        </div>
                    </div>
                </div>
                
                <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普图画') || viewForm.rawWorksType === '2')" class="detail-item">
                    <span class="label">科普图画：</span>
                    <div class="file-item">
                        <!-- <img src="../../assets/applyRey/mp4.jpg" class="file-icon" /> -->
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewFile('科普图画')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadFile('科普图画')">下载</el-button>
                </div>
                </div>
                </div>

                <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普短视频') || viewForm.rawWorksType === '3')" class="detail-item">
                    <span class="label">科普短视频：</span>
                    <div class="file-item">
                        <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewFile('科普短视频')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadFile('科普短视频')">下载</el-button>
                        </div>
                    </div>
                </div>

                <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普讲座') || viewForm.rawWorksType === '4')" class="detail-item">
                    <span class="label">科普讲座：</span>
                    <div class="file-item">
                        <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewFile('科普讲座')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadFile('科普讲座')">下载</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-divider"></div>
            
            <div class="section-title">作品授权书</div>
            <div class="detail-grid">
                <div class="detail-item">
                    <div class="file-item">
                        <img src="../../assets/applyRey/pdf.png" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewFile('授权书')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadFile('授权书')">下载</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-divider"></div>
            
            <div class="section-title">审核评语</div>
            <div class="detail-grid">
                <div class="detail-item" v-for="(check, index) in viewForm.checkList" :key="index">
                    <span class="label">{{ check.level === 1 ? '合规审核' : check.level === 2 ? '学术初审' : check.level === 3 ? '专家复评' : check.level === 4 ? '合规审核' : '审核人'+check.level }}：</span>
                    <span class="value">{{check.msg || '-'}}</span>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关闭</el-button>
        </span>
    </el-dialog>

    <!-- 打分弹窗 -->
    <el-dialog 
        title="评分审核" 
        :visible.sync="scoreDialogVisible" 
        width="900px" 
        :close-on-click-modal="false">
        <div class="score-content">
            <div class="section-title">专业信息</div>
            <div class="detail-grid">
                <div class="detail-item">
                    <span class="label">项目编号：</span>
                    <span class="value">{{scoreForm.rowData.projectCode}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">作品名称：</span>
                    <span class="value">{{scoreForm.rowData.worksName}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">项目主题：</span>
                    <span class="value">{{scoreForm.rowData.projectCase}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">创作时间：</span>
                    <span class="value">{{scoreForm.rowData.workTime || ''}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">作品成绩：</span>
                    <span class="value">{{scoreForm.rowData.isGood === 1 ? '优秀' : '一般'}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">内容形式：</span>
                    <span class="value">{{scoreForm.rowData.worksType}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">作品状态：</span>
                    <span class="value">{{scoreForm.rowData.statusText}}</span>
                </div>
                <div class="detail-item">
                    <span class="label">备注：</span>
                    <span class="value">{{scoreForm.rowData.des || '-'}}</span>
                </div>
                
                <!-- 根据内容形式显示相应的文件 -->
                <div v-if="scoreForm.rowData.worksType && (scoreForm.rowData.worksType.includes('科普文章') || scoreForm.rowData.rawWorksType === '1')" class="detail-item">
                    <span class="label">科普文章：</span>
                    <div class="file-item">
                        <img src="../../assets/applyRey/word.png" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewScoreFile('科普文章')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadScoreFile('科普文章')">下载</el-button>
                        </div>
                    </div>
                </div>
                
                <div v-if="scoreForm.rowData.worksType && (scoreForm.rowData.worksType.includes('科普图画') || scoreForm.rowData.rawWorksType === '2')" class="detail-item">
                    <span class="label">科普图画：</span>
                    <div class="file-item">
                        <!-- <img src="../../assets/applyRey/mp4.jpg" class="file-icon" /> -->
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewScoreFile('科普图画')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadScoreFile('科普图画')">下载</el-button>
                    </div>
                    </div>
                </div>

                <div v-if="scoreForm.rowData.worksType && (scoreForm.rowData.worksType.includes('科普短视频') || scoreForm.rowData.rawWorksType === '3')" class="detail-item">
                    <span class="label">科普短视频：</span>
                    <div class="file-item">
                        <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewScoreFile('科普短视频')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadScoreFile('科普短视频')">下载</el-button>
                        </div>
                    </div>
                </div>

                <div v-if="scoreForm.rowData.worksType && (scoreForm.rowData.worksType.includes('科普讲座') || scoreForm.rowData.rawWorksType === '4')" class="detail-item">
                    <span class="label">科普讲座：</span>
                    <div class="file-item">
                        <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewScoreFile('科普讲座')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadScoreFile('科普讲座')">下载</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-divider"></div>
            
            <div class="section-title">作品授权书</div>
            <div class="detail-grid">
                <div class="detail-item">
                    <div class="file-item">
                        <img src="../../assets/applyRey/pdf.png" class="file-icon" />
                        <div class="file-actions">
                            <el-button type="text" class="action-btn" @click="viewScoreFile('授权书')">查看</el-button>
                            <el-button type="text" class="action-btn" @click="downloadScoreFile('授权书')">下载</el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section-divider"></div>

            <div class="section-title">评分审核</div>
            <div v-if="i === 1">
                <div class="review-rules">
                    <div class="rule-title">学术初审规则</div>
                    <div class="rule-item">
                        <div class="rule-header">(1) 两项评分均符合要求，则学术初审通过；</div>
                        <div class="rule-header">(2) 任何一项不符合要求，则学术初审不通过。</div>
                        <div class="rule-header">评审项：</div>
                        <div class="rule-content">
                            <div class="review-item">
                                <span class="item-label">1. 科学性：</span>
                                <span class="item-desc">评审委员根据专业知识及可靠资料，判断作品内容是否符合科学原理，有无误导性信息，是否具有权威性和可靠性。</span>
                            </div>
                            <div class="review-item">
                                <span class="item-label">2. 逻辑性：</span>
                                <span class="item-desc">作品中的内容与结论是否有逻辑上的因果性。</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-if="i === 1" class="score-item">
                <span class="label">审核结果：</span>
                <div class="radio-group-compact">
                    <el-radio v-model="scoreForm.result" label="pass">通过</el-radio>
                    <el-radio v-model="scoreForm.result" label="fail">不通过</el-radio>
                </div>
            </div>
            <div v-if="i === 1" class="score-section">
                <div class="section-header">评语</div>
                <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入评语"
                    v-model="scoreForm.msg"
                    :required="scoreForm.result === 'fail'"
                    :class="{ 'is-required': scoreForm.result === 'fail' }">
                </el-input>
                <div v-if="scoreForm.result === 'fail' && !scoreForm.msg" class="error-message">
                    请填写评语
                </div>
            </div>
            <div v-if="i === 2" class="score-form">
                <div class="score-section">
                    <div class="section-header">一、内容策划（0-9分）</div>
                    <div class="score-desc">
                        <div class="desc-item">
                            <el-tooltip placement="right" effect="light">
                                <div slot="content">从某段视频中剪辑的片段，限制条件交代不清楚，可能形成误导。</div>
                                <span>1. 内容完整，有必要的条件描述，避免引起绝对化误导。</span>
                            </el-tooltip>
                        </div>
                        <div class="desc-item">
                            <el-tooltip placement="right" effect="light">
                                <div slot="content">比如，只讲解了疾病的定义，没有提示高发人群的特征，或没有提示如何才能确诊，或者也没有提示需要通过哪些方式预防等等。</div>
                                <span>2. 有观点或行动建议，有引导思考或行动的元素，或有总结提醒，让用户有获得感。</span>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="score-slider">
                        <el-slider v-model="scoreForm.contentScore" :min="0" :max="9" show-stops></el-slider>
                        <span class="score-value">当前分数: {{ scoreForm.contentScore }}</span>
                    </div>
                </div>

                <div class="score-section">
                    <div class="section-header">二、创新与创意（0-9分）</div>
                    <div class="score-desc">
                        <div class="desc-item">
                            <el-tooltip placement="right" effect="light">
                                <div slot="content">讲了一个便于理解的故事，总结了 3 个"4"，编排了顺口溜等。</div>
                                <span>1. 视角独特，评审人员根据对网络上已有作品的深入了解，判断该作品是否提供了相对新颖的观点或切入角度，避免了老生常谈。</span>
                            </el-tooltip>
                        </div>
                        <div class="desc-item">
                            <span>2. 叙事生动，是否采用故事化、场景化、角色扮演等手法，使内容更具吸引力。</span>
                        </div>
                        <div class="desc-item">
                            <span>3. 跨领域融合融合图表、动图、动画、游戏等元素，增加了趣味性和参与感。</span>
                        </div>
                    </div>
                    <div class="score-slider">
                        <el-slider v-model="scoreForm.innovationScore" :min="0" :max="9" show-stops></el-slider>
                        <span class="score-value">当前分数: {{ scoreForm.innovationScore }}</span>
                    </div>
                </div>

                <div class="score-section">
                    <div class="section-header">三、表达与制作（0-9分）</div>
                    <div class="score-desc">
                        <div class="desc-item">
                            <span>1. 流畅度：表达流畅，无不必要的停顿或重复，使大众能轻松理解。</span>
                        </div>
                        <div class="desc-item">
                            <span>2. 画面：画面清晰合理，人像位置合适，无不必要的画面，剪辑流畅，字幕准确。</span>
                        </div>
                        <div class="desc-item">
                            <span>3. 音效：背景音乐音量合理，声音不刺耳，不干扰人声。</span>
                        </div>
                    </div>
                    <div class="score-slider">
                        <el-slider v-model="scoreForm.expressionScore" :min="0" :max="9" show-stops></el-slider>
                        <span class="score-value">当前分数: {{ scoreForm.expressionScore }}</span>
                    </div>
                </div>

                <!-- 简化后的总分显示部分 -->
                <div class="score-section total-score">
                    <div class="final-score">
                        总分: {{ displayTotalScore }}
                    </div>
                </div>

                <!-- 添加评语输入框和审核状态选择 -->
                <div class="score-section" v-if="false">
                    <div class="section-header">审核状态</div>
                    <el-radio-group v-model="scoreForm.status">
                        <el-radio :label="1">审核通过</el-radio>
                        <el-radio :label="2">审核不通过</el-radio>
                    </el-radio-group>
                </div>

                <div class="score-section">
                    <div class="section-header">评语</div>
                    <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入评语"
                        v-model="scoreForm.remark">
                    </el-input>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="scoreDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitScore">提交</el-button>
        </span>
    </el-dialog>

    <!-- 添加视频播放弹窗 -->
    <el-dialog
        :title="videoTitle"
        :visible.sync="videoDialogVisible"
        :width="isMobile ? '95%' : '800px'"
        :close-on-click-modal="false"
        :fullscreen="isMobile"
        class="video-dialog"
        @close="closeVideoDialog">
        <div class="video-container">
            <video
                ref="videoPlayer"
                class="video-player"
                controls
                :src="currentVideoUrl"
                controlsList="nodownload"
                preload="auto"
                playsinline
                webkit-playsinline
                x5-video-player-type="h5"
                x5-video-player-fullscreen="true"
                x5-video-orientation="portraint"
                x-webkit-airplay="allow"
                x5-playsinline="true"
                style="object-fit: contain; background: #000;">
                您的浏览器不支持 HTML5 视频播放
            </video>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            i: 1, // 修改默认值为学术审核
            academicSearch: {
                checkStatus: '-1'
            },
            expertSearch: {
                checkStatus: '-1'
            },
            tableData: [], // 表格数据
            total: 0, // 总数
            pageNum: 1, // 当前页
            pageSize: 10, // 每页条数
            dialogVisible: false, // 查看详情弹窗
            scoreDialogVisible: false, // 打分弹窗
            viewForm: {}, // 查看详情的数据
            refreshLoading: false, // 刷新按钮加载状态
            submitLoading: false, // 提交按钮锁
            scoreHistory: [
                {
                    reviewer: '张三',
                    score: 4,
                    remark: '内容详实，论述充分',
                    time: '2024-03-20 14:30:00'
                },
                {
                    reviewer: '李四',
                    score: 3,
                    remark: '整体不错，有待改进',
                    time: '2024-03-19 16:20:00'
                }
            ],
            scoreForm: {
                result: '',
                contentScore: 0,      // 内容策划分数
                innovationScore: 0,   // 创新与创意分数
                expressionScore: 0,   // 表达与制作分数
                remark: '',           // 评语（专家复审使用）
                msg: '',              // 评语（学术审核使用）
                status: 1,            // 默认审核通过，固定值
                rowData: {},
                isModifying: false,   // 标记为新评分
            },
            videoDialogVisible: false,
            currentVideoUrl: '',
            videoTitle: '',
            isMobile: false,
        }
    },
    
    methods: {
        // 切换导航
        ToggleNav(i) {
            this.i = i;
            this.pageNum = 1;
            this.Query(i === 1 ? 'academic' : 'expert');
        },

        // 查询数据
        Query(type) {
            // 构建请求参数
            const params = {
                pageNum: parseInt(this.pageNum) || 1,
                pageSize: parseInt(this.pageSize) || 10,
                level: type === 'academic' ? 2 : 3 // 学术审核传递level=2，专家复审传递level=3，确保是整数
            };
            
            // 如果不是全部状态，则添加checkStatus参数
            const checkStatus = type === 'academic' ? this.academicSearch.checkStatus : this.expertSearch.checkStatus;
            if (checkStatus !== '-1') {
                params.checkStatus = parseInt(checkStatus);
            }

            const url = '/api/v1/works/checklist';
            
            console.log('查询参数:', params);
            
            this.$get(url, params).then(res => {
                if (res.data.code === 200) {
                    // 根据接口返回格式调整数据获取方式
                    this.tableData = res.data.rows || [];
                    this.total = res.data.total || 0;
                    
                    this.tableData = this.tableData.map(item => ({
                        ...item,
                        statusText: this.getStatusText(item.checkStatus),
                        worksType: this.getWorksTypeText(item.worksType)
                    }));
                } else {
                    this.$message.error(res.data.msg || '获取列表失败');
                }
            }).catch(err => {
                console.error('获取列表失败:', err);
                this.$message.error('获取列表失败');
            });
        },

        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                0: '待审核',
                1: '审核通过',
                2: '审核不通过'
            };
            return statusMap[status] || '未知状态';
        },

        // 获取专家评分
        getExpertScore(row) {
            if (!row.checkList || row.checkList.length === 0) {
                return '0';
            }
            
            // 查找level为3的评审记录
            const expertCheck = row.checkList.find(check => check.level === 3);
            if (expertCheck && expertCheck.score !== null && expertCheck.score !== undefined) {
                return expertCheck.score.toFixed(2);
            }
            
            return '0';
        },

        // 获取作品类型文本
        getWorksTypeText(types) {
            const typeMap = {
                '1': '科普文章',
                '2': '科普图画',
                '3': '科普短视频',
                '4': '科普讲座'
            };
            
            if (!types) return '';
            
            const typeArray = types.split(',');
            return typeArray.map(type => typeMap[type.trim()] || type).join('，');
        },

        // 处理页码变化
        handleCurrentChange(val) {
            this.pageNum = parseInt(val);
            this.Query(this.i === 1 ? 'academic' : 'expert');
        },
        // 处理每页条数变化
        handleSizeChange(val) {
            this.pageSize = parseInt(val);
            this.pageNum = 1; // 重置到第一页
            this.Query(this.i === 1 ? 'academic' : 'expert');
        },

        // 查看详情
        handleView(row) {
            this.$get(`/api/v1/works/workinfo/${row.id}`).then(res => {
                if (res.data.code === 200) {
                    // 获取完整的作品详情后显示
                    const detail = res.data.data;
                    // 保存原始的worksType值用于条件判断
                    const rawWorksType = detail.worksType;
                    // 转换worksType为文本描述
                    detail.worksType = this.getWorksTypeText(detail.worksType);
                    this.viewForm = {
                        ...row,
                        ...detail,
                        rawWorksType, // 保存原始值
                        des: detail.des || ''
                    };
            this.dialogVisible = true;
                } else {
                    this.$message.error(res.data.msg || '获取作品详情失败');
                }
            }).catch(err => {
                console.error('获取作品详情失败:', err);
                this.$message.error('获取作品详情失败');
            });
        },

        // 查看文件
        viewFile(fileType) {
            let filePath = '';
            
            switch(fileType) {
                case '科普文章':
                    filePath = this.viewForm.workFile;
                    break;
                case '科普图画':
                    filePath = this.viewForm.workPicFile;
                    break;
                case '科普短视频':
                case '科普讲座':
                    // 对于视频文件，使用新的播放方式
                    filePath = fileType === '科普短视频' ? 
                        this.viewForm.workVedioFile : 
                        this.viewForm.workJzFile;
                    if (filePath) {
                        this.playVideo(filePath, fileType);
                        return;
                    }
                    break;
                case '授权书':
                    filePath = this.viewForm.workAuthFile;
                    break;
                default:
                    filePath = '';
            }
            
            if (filePath) {
                window.open(filePath, '_blank');
            } else {
                this.$message.info(`查看${fileType}文件`);
            }
        },

        // 下载文件
        downloadFile(fileType) {
            let filePath = '';
            
            switch(fileType) {
                case '科普文章':
                    filePath = this.viewForm.workFile;
                    break;
                case '科普图画':
                    filePath = this.viewForm.workPicFile;
                    break;
                case '科普短视频':
                    filePath = this.viewForm.workVedioFile;
                    break;
                case '科普讲座':
                    filePath = this.viewForm.workJzFile;
                    break;
                case '授权书':
                    filePath = this.viewForm.workAuthFile;
                    break;
                default:
                    filePath = '';
            }
            
            if (filePath) {
                // 确保使用https协议
                if (filePath.startsWith('http:')) {
                    filePath = filePath.replace('http:', 'https:');
                }
                
                const link = document.createElement('a');
                link.href = filePath;
                link.download = filePath.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                this.$message.info(`暂无${fileType}文件`);
            }
        },
        
        // 打分弹窗查看文件
        viewScoreFile(fileType) {
            let filePath = '';
            
            switch(fileType) {
                case '科普文章':
                    filePath = this.scoreForm.rowData.workFile;
                    break;
                case '科普图画':
                    filePath = this.scoreForm.rowData.workPicFile;
                    break;
                case '科普短视频':
                case '科普讲座':
                    // 对于视频文件，使用新的播放方式
                    filePath = fileType === '科普短视频' ? 
                        this.scoreForm.rowData.workVedioFile : 
                        this.scoreForm.rowData.workJzFile;
                    if (filePath) {
                        this.playVideo(filePath, fileType);
                        return;
                    }
                    break;
                case '授权书':
                    filePath = this.scoreForm.rowData.workAuthFile;
                    break;
                default:
                    filePath = '';
            }
            
            if (filePath) {
                window.open(filePath, '_blank');
            } else {
                this.$message.info(`查看${fileType}文件`);
            }
        },

        // 打分弹窗下载文件
        downloadScoreFile(fileType) {
            let filePath = '';
            
            switch(fileType) {
                case '科普文章':
                    filePath = this.scoreForm.rowData.workFile;
                    break;
                case '科普图画':
                    filePath = this.scoreForm.rowData.workPicFile;
                    break;
                case '科普短视频':
                    filePath = this.scoreForm.rowData.workVedioFile;
                    break;
                case '科普讲座':
                    filePath = this.scoreForm.rowData.workJzFile;
                    break;
                case '授权书':
                    filePath = this.scoreForm.rowData.workAuthFile;
                    break;
                default:
                    filePath = '';
            }
            
            if (filePath) {
                // 确保使用https协议
                if (filePath.startsWith('http:')) {
                    filePath = filePath.replace('http:', 'https:');
                }
                
                const link = document.createElement('a');
                link.href = filePath;
                link.download = filePath.split('/').pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                this.$message.info(`暂无${fileType}文件`);
            }
        },

        // 打分
        handleScore(row) {
            this.$get(`/api/v1/works/workinfo/${row.id}`).then(res => {
                if (res.data.code === 200) {
                    const detail = res.data.data;
                    
                    // 初始化打分表单
                    this.scoreForm = {
                        contentScore: 0,
                        innovationScore: 0,
                        expressionScore: 0,
                        remark: '',
                        status: 1,
                        isModifying: false, // 标记为新评分
                        rowData: {
                            ...row,
                            ...detail,
                            rawWorksType: detail.worksType,
                            worksType: this.getWorksTypeText(detail.worksType),
                            des: detail.des || ''
                        }
                    };
                    this.scoreDialogVisible = true;
                } else {
                    this.$message.error(res.data.msg || '获取作品详情失败');
                }
            }).catch(err => {
                console.error('获取作品详情失败:', err);
                this.$message.error('获取作品详情失败');
            });
        },

        handleModifyScore(row) {
            this.$get(`/api/v1/works/workinfo/${row.id}`).then(res => {
                if (res.data.code === 200) {
                    const detail = res.data.data;
                    
                    // 找到专家评分记录
                    const expertCheck = detail.checkList.find(check => check.level === 3);
                    if (expertCheck && expertCheck.scoreInfo) {
                        try {
                            // 解析scoreInfo，注意处理JSON字符串格式
                            let scoreInfoStr = expertCheck.scoreInfo;
                            if (typeof scoreInfoStr === 'string') {
                                try {
                                    scoreInfoStr = JSON.parse(scoreInfoStr);
                                } catch (e) {
                                    // 如果解析失败，说明可能不是JSON格式，直接使用原字符串
                                }
                            }
                            
                            // 分割得分数据
                            const [contentScore, innovationScore, expressionScore] = scoreInfoStr.split('-').map(Number);
                            
                            // 初始化打分表单
                            this.scoreForm = {
                                contentScore: contentScore || 0,
                                innovationScore: innovationScore || 0,
                                expressionScore: expressionScore || 0,
                                remark: expertCheck.msg || '',
                                status: 1,
                                isModifying: true, // 标记为修改评分
                                rowData: {
                                    ...row,
                                    ...detail,
                                    rawWorksType: detail.worksType,
                                    worksType: this.getWorksTypeText(detail.worksType),
                                    des: detail.des || ''
                                }
                            };
                            
                            this.scoreDialogVisible = true;
                        } catch (error) {
                            console.error('解析评分数据失败:', error);
                            this.$message.error('解析评分数据失败');
                        }
                    } else {
                        this.$message.warning('未找到原评分记录');
                    }
                } else {
                    this.$message.error(res.data.msg || '获取作品详情失败');
                }
            }).catch(err => {
                console.error('获取作品详情失败:', err);
                this.$message.error('获取作品详情失败');
            });
        },

        submitScore() {
            if (this.submitLoading) {
                return;
            }
            
            try {
                this.submitLoading = true;
                
                if (this.i === 1) {
                    if (!this.scoreForm.result) {
                        this.$message.warning('请选择审核结果');
                        this.submitLoading = false;
                        return;
                    }
                    
                    if (this.scoreForm.result === 'fail' && !this.scoreForm.msg) {
                        this.$message.warning('请填写评语');
                        this.submitLoading = false;
                        return;
                    }
                    
                    const worksId = this.scoreForm.rowData.id;
                    const status = this.scoreForm.result === 'pass' ? 1 : 2;
                    const msg = encodeURIComponent(this.scoreForm.msg || '');
                    const score = 100;
                    
                    const url = `/api/v1/works/workscheck?level=2&worksId=${worksId}&status=${status}&msg=${msg}&score=${score}`;
                    
                    this.$post(url, {}).then(res => {
                        if (res.data.code === 200) {
                            this.$message.success(res.data.msg || '提交成功');
                            this.scoreDialogVisible = false;
                            this.Query('academic');
                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                    }).catch(err => {
                        console.error('提交失败:', err);
                        let errorMsg = '未知错误';
                        if (err.response && err.response.data && err.response.data.msg) {
                            errorMsg = err.response.data.msg;
                        } else if (err.message) {
                            errorMsg = err.message;
                        }
                        this.$message.error('提交失败，错误信息: ' + errorMsg);
                    }).finally(() => {
                        this.submitLoading = false;
                    });
                } else {
                    // 专家复审
                    let score = 0;
                    try {
                        score = parseFloat(this.calculateTotalScore);
                        if (isNaN(score) || score === 0) {
                            score = 0;
                            console.warn('计算得到的分数无效，使用默认值0');
                        }
                    } catch (e) {
                        score = 0;
                        console.error('计算分数时发生错误:', e);
                    }
                    
                    // 检查是否至少有两个评分项不为0
                    const nonZeroScores = [
                        this.scoreForm.contentScore > 0,
                        this.scoreForm.innovationScore > 0,
                        this.scoreForm.expressionScore > 0
                    ].filter(Boolean).length;
                    
                    if (nonZeroScores < 2) {
                        this.$message.warning('请至少在两个评分项中给出非零分数');
                        this.submitLoading = false;
                        return;
                    }
                    
                    // 获取作品ID
                    const worksId = this.scoreForm.rowData.id;
                    const scoreInfo = `${this.scoreForm.contentScore}-${this.scoreForm.innovationScore}-${this.scoreForm.expressionScore}`;
                    
                    // 判断是修改还是新评分
                    if (this.scoreForm.isModifying) {
                        // 修改评分
                        const encodedScoreInfo = encodeURIComponent(scoreInfo);
                        const msg = encodeURIComponent(this.scoreForm.remark || '');
                        const url = `/system/check/updateScore?worksId=${worksId}&score=${score}&scoreInfo=${encodedScoreInfo}&msg=${msg}`;
                        
                        this.$post(url, {}).then(res => {
                            if (res.data.code === 200) {
                                this.$message.success('修改成功');
                                this.scoreDialogVisible = false;
                                this.Query('expert');
                            } else {
                                this.$message.error(res.data.msg || '修改失败');
                            }
                        }).catch(err => {
                            console.error('修改失败:', err);
                            let errorMsg = '未知错误';
                            if (err.response && err.response.data && err.response.data.msg) {
                                errorMsg = err.response.data.msg;
                            } else if (err.message) {
                                errorMsg = err.message;
                            }
                            this.$message.error('修改失败，错误信息: ' + errorMsg);
                        }).finally(() => {
                            this.submitLoading = false;
                        });
                    } else {
                        // 新评分
                        const msg = encodeURIComponent(this.scoreForm.remark || '');
                        const encodedScoreInfo = encodeURIComponent(scoreInfo);
                        const url = `/api/v1/works/workscheck?level=3&worksId=${worksId}&status=1&msg=${msg}&score=${score}&scoreInfo=${encodedScoreInfo}`;
                        
                        this.$post(url, {}).then(res => {
                            if (res.data.code === 200) {
                                this.$message.success(res.data.msg || '提交成功');
                                this.scoreDialogVisible = false;
                                this.Query('expert');
                            } else {
                                this.$message.error(res.data.msg || '提交失败');
                            }
                        }).catch(err => {
                            console.error('提交失败:', err);
                            let errorMsg = '未知错误';
                            if (err.response && err.response.data && err.response.data.msg) {
                                errorMsg = err.response.data.msg;
                            } else if (err.message) {
                                errorMsg = err.message;
                            }
                            this.$message.error('提交失败，错误信息: ' + errorMsg);
                        }).finally(() => {
                            this.submitLoading = false;
                        });
                    }
                }
            } catch (error) {
                console.error('提交过程发生错误:', error);
                this.$message.error('提交失败，请检查输入数据');
            }
        },

        // 刷新学术审核列表
        refreshAcademicList() {
            this.refreshLoading = true;
            this.$get('/api/v1/works/refreshChecklist', { level: 2 }).then(res => {
                if (res.data.code === 200) {
                    this.$message.success('刷新成功');
                    this.Query('academic');
                } else {
                    this.$message.error(res.data.msg || '刷新失败');
                }
            }).catch(err => {
                console.error('刷新列表失败:', err);
                this.$message.error('刷新失败');
            }).finally(() => {
                this.refreshLoading = false;
            });
        },

        // 添加视频播放相关方法
        playVideo(url, title) {
            this.currentVideoUrl = url;
            this.videoTitle = title;
            this.videoDialogVisible = true;
            // 等待 DOM 更新后播放视频
            this.$nextTick(() => {
                if (this.$refs.videoPlayer) {
                    this.$refs.videoPlayer.play();
                }
            });
        },
        closeVideoDialog() {
            if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.pause();
                this.$refs.videoPlayer.currentTime = 0;
            }
            this.currentVideoUrl = '';
            this.videoTitle = '';
        },
        // 添加检测移动设备方法
        checkIsMobile() {
            this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        // 添加检查专家是否已审核通过的方法
        hasExpertApproved(row) {
            if (!row.checkList || !Array.isArray(row.checkList)) {
                return false;
            }
            // 查找level为3的记录，判断status是否为1
            return row.checkList.some(check => check.level === 3 && check.status === 1);
        },
    },

    computed: {
        calculateTotalScore() {
            try {
            const contentWeight = 0.3;
            const innovationWeight = 0.45;
            const expressionWeight = 0.25;
                
                const contentScore = parseFloat(this.scoreForm.contentScore) || 0;
                const innovationScore = parseFloat(this.scoreForm.innovationScore) || 0;
                const expressionScore = parseFloat(this.scoreForm.expressionScore) || 0;
            
            const weightedScore = (
                    contentScore * contentWeight +
                    innovationScore * innovationWeight +
                    expressionScore * expressionWeight
            ) / 9 * 100;
            
                // 确保结果为有效数字，如果无效或为0则返回默认值1
                const result = parseFloat(weightedScore.toFixed(2));
                return !isNaN(result) && result > 0 ? result : 0;
            } catch (e) {
                console.error('计算分数时出错:', e);
                return 1; // 出错返回默认值1
            }
        },
        
        // 添加一个用于显示的计算属性
        displayTotalScore() {
            return this.calculateTotalScore.toFixed(2);
        }
    },

    created() {
        this.Query('academic'); 
        this.checkIsMobile();
        window.addEventListener('resize', this.checkIsMobile);
    },
    beforeDestroy() {

        window.removeEventListener('resize', this.checkIsMobile);
    }
}
</script>
<style scoped>
    .custom-text-size {
        font-size: 16px;
        text-align: center;
    }


    .Order {
        width: 100%;
        min-width: 910px;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
        position: relative;
        padding-bottom: 5px;
    }

    .no-wrap-table {
        width: max-content !important;
        min-width: 100%;
    }

    .AboutCont {
        overflow-x: auto;
        padding-bottom: 5px;
    }

    .table-container::-webkit-scrollbar,
    .AboutCont::-webkit-scrollbar {
        width: 100%;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table-container::-webkit-scrollbar-thumb,
    .AboutCont::-webkit-scrollbar-thumb {
        background: #909399;
        border-radius: 4px;
    }

    .table-container::-webkit-scrollbar-thumb:hover,
    .AboutCont::-webkit-scrollbar-thumb:hover {
        background: #606266;
    }

    .table-container::-webkit-scrollbar-track,
    .AboutCont::-webkit-scrollbar-track {
        background: #e4e7ed;
        border-radius: 4px;
    }

    ::v-deep .el-table th {
        text-align: center;
        white-space: nowrap !important;
        color: #303030;
        font-weight: bold;
        background-color: #f5f5f5;
    }

    ::v-deep .el-table td {
        text-align: center;
        white-space: nowrap !important;
    }

    ::v-deep .el-table .cell {
        white-space: nowrap !important;
        line-height: 23px;
    }

    .OrderTop {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #ddd;
        position: relative;
        margin-bottom: 20px;
        width: 70%;
    }
    .refresh-button {
        margin-left: 10px;
    }
    
    .Nav{
        flex: 1;
        display: flex;
        align-items: center;
        width: 60%;
    }
    .NavItem{
        font-size: 16px;
        flex: 1;
        padding: 15px 0;
        text-align: center;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
        position: relative;
    }
    .NavItem.Act{
        color: #e69d26;
    }
    .NavItem.Act::after{
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background: #e69d26;
        bottom: -2px;
        left: 0;
    }
    .NavMsg{
        color: #666;
        font-size: 16px;
    }
    .PageDis{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }
    .ColorBlue {
        color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }
    .ColorBlue:hover {
        color: #fff !important;
        background-color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }
    .Search {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .SearchWid {
        width: 200px;
        margin-right: 10px;
    }
    @media only screen and (max-width: 768px) {
        .OrderTop {
            width: 100%;
            margin-bottom: 15px;
        }
        .NavItem {
            font-size: 14px;
            padding: 10px 5px;
        }
        .table-container {
            margin: 0;
            overflow-x: auto;
            padding-bottom: 5px;
        }
        ::v-deep .el-table th {
            font-size: 14px;
            padding: 8px 0;
        }
        ::v-deep .el-table td {
            font-size: 14px;
            padding: 5px 0;
        }
        .Order {
            min-width: auto;
            width: 100%;
        }
        .PageDis {
            padding: 15px 5px;
        }
        .detail-content, .score-content {
            padding: 15px 10px;
        }
        .section-title {
            font-size: 15px;
            margin-bottom: 15px;
        }
        .detail-grid {
            grid-template-columns: 1fr;
            gap: 15px;
        }
        .detail-item {
            flex-direction: column;
            align-items: flex-start;
        }
        .detail-item .label {
            width: 100%;
            margin-bottom: 5px;
        }
        .score-section {
            padding: 15px;
            margin-bottom: 20px;
        }
        .section-header {
            font-size: 15px;
        }
        .desc-item {
            padding-left: 10px;
        }
        .score-slider {
            padding: 0 10px;
        }
        ::v-deep .el-dialog {
            width: 95% !important;
            margin-top: 10vh !important;
            max-width: 100%;
            box-sizing: border-box;
            max-height: 80vh;
            display: flex;
            flex-direction: column;
        }
        

        ::v-deep .el-dialog__body {
            padding: 10px;
            box-sizing: border-box;
            width: 100%;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            flex: 1;
        }
        
        .score-content {
            padding: 10px;
            box-sizing: border-box;
            width: 100%;
        }
        
   
        ::v-deep .el-textarea__inner {
            width: 100%;
            box-sizing: border-box;
        }
        
        ::v-deep .el-dialog__wrapper {
            overflow: hidden;
        }
        
        ::v-deep .el-dialog__header {
            padding: 10px;
            flex-shrink: 0;
        }
        
        ::v-deep .el-dialog__footer {
            padding: 10px;
            flex-shrink: 0;
        }
        

        .score-item {
            margin-bottom: 15px;
            padding: 0 10px;
            box-sizing: border-box;
            width: 100%;
        }
        
        .score-item .label {
            display: block;
            margin-bottom: 8px;
            font-weight: bold;
            font-size: 14px;
        }
        
        .radio-group-compact {
            display: flex;
            flex-wrap: nowrap;
            width: 100%;
            padding: 0;
            box-sizing: border-box;
        }
        
        .radio-group-compact .el-radio {
            margin-right: 15px;
            margin-left: 0;
            padding: 6px 0;
            text-align: left;
            font-size: 13px;
            min-width: 0;
            box-sizing: border-box;
        }
        
        .radio-group-compact .el-radio:last-child {
            margin-right: 0;
        }
        
        .radio-group-compact .el-radio__input {
            display: inline-block;
            margin-right: 5px;
        }
        
        .radio-group-compact .el-radio__label {
            padding-left: 0;
            white-space: nowrap;
            font-size: 13px;
        }
        
        .radio-group-compact .el-radio.is-checked {
            color: #0385EB;
        }
        
        .score-section {
            padding: 10px;
            box-sizing: border-box;
            width: 100%;
        }
        
        .score-section .section-header {
            margin-bottom: 8px;
            font-weight: bold;
            font-size: 14px;
        }
        
        .score-section .radio-group-compact {
            display: flex;
            flex-wrap: nowrap;
            width: 100%;
            padding: 0;
            box-sizing: border-box;
        }
        
        .score-section .radio-group-compact .el-radio {
            margin-right: 15px;
            margin-left: 0;
            padding: 6px 0;
            text-align: left;
            font-size: 13px;
            min-width: 0;
            box-sizing: border-box;
        }
        
        .score-section .radio-group-compact .el-radio:last-child {
            margin-right: 0;
        }
        
        .score-section .radio-group-compact .el-radio__input {
            display: inline-block;
            margin-right: 5px;
        }
        
        .score-section .radio-group-compact .el-radio__label {
            padding-left: 0;
            white-space: nowrap;
            font-size: 13px;
        }
        
        .score-section .radio-group-compact .el-radio.is-checked {
            color: #0385EB;
        }
    }

    .detail-content, .score-content {
        padding: 20px;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        border-left: 4px solid #409EFF;
        padding-left: 10px;
        margin-bottom: 20px;
    }

    .section-divider {
        height: 1px;
        background-color: #EBEEF5;
        margin: 20px 0;
    }

    .detail-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        margin-bottom: 20px;
    }

    .detail-item {
        display: flex;
        align-items: flex-start;
    }

    .detail-item .label {
        width: 100px;
        color: #606266;
        font-weight: bold;
    }

    .detail-item .value {
        flex: 1;
        color: #333;
    }

    .file-item {
        display: flex;
        align-items: center;
    }

    .file-icon {
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }

    .file-actions {
        display: flex;
        gap: 15px;
    }

    .action-btn {
        color: #409EFF;
        font-size: 14px;
    }

    .action-btn:hover {
        color: #66b1ff;
    }

    .review-info {
        background-color: #f8f9fa;
        border-radius: 4px;
        padding: 20px;
    }

    .review-item {
        margin-bottom: 15px;
        line-height: 24px;
    }

    .review-item:last-child {
        margin-bottom: 0;
    }

    .review-item .label {
        display: inline-block;
        width: 100px;
        color: #606266;
        font-weight: bold;
    }

    .review-item .value {
        color: #333;
    }

    .score-history {
        margin-top: 20px;
    }

    .score-form {
        padding: 20px;
        background-color: #f8f9fa;
        border-radius: 4px;
    }

    .score-item {
        margin-bottom: 20px;
    }

    .score-item .label {
        display: block;
        margin-bottom: 10px;
        color: #606266;
        font-weight: bold;
    }

    .score-item .el-radio-group {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 400px;
    }

    ::v-deep .el-dialog__body {
        padding: 0;
    }

    .OrderTop .NavItem {
        font-size: 14px;
    }

    ::v-deep .el-slider__runway {
        height: 8px;
        border-radius: 4px;
        background-color: #e4e7ed;
    }

    ::v-deep .el-slider__bar {
        height: 8px;
        border-radius: 4px;
        background-color: #0385EB;
    }

    ::v-deep .el-slider__button {
        border: 2px solid #0385EB;
        background-color: #fff;
        width: 16px;
        height: 16px;
        margin-top: -4px;
    }

    .review-rules {
        background-color: #f8f9fa;
        border-radius: 4px;
        padding: 20px;
        margin-bottom: 20px;
    }

    .rule-title {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 15px;
    }

    .rule-item {
        margin-bottom: 15px;
    }

    .rule-header {
        font-weight: bold;
        margin-bottom: 10px;
        color: #606266;
    }

    .review-item {
        margin-bottom: 10px;
        padding-left: 20px;
    }

    .item-label {
        font-weight: bold;
        color: #606266;
    }

    .item-desc {
        color: #606266;
        line-height: 1.5;
    }

    .score-section {
        margin-bottom: 30px;
        background-color: #f8f9fa;
        padding: 20px;
        border-radius: 4px;
    }

    .section-header {
        font-size: 16px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 15px;
    }

    .score-desc {
        margin-bottom: 20px;
    }

    .desc-item {
        color: #606266;
        line-height: 1.6;
        margin-bottom: 10px;
        padding-left: 20px;
        cursor: help;
    }

    .score-slider {
        padding: 0 20px;
    }

    .score-value {
        display: block;
        text-align: right;
        color: #409EFF;
        margin-top: 10px;
        font-weight: bold;
    }

    ::v-deep .el-tooltip__popper {
        max-width: 300px;
        line-height: 1.6;
        padding: 10px;
        font-size: 14px;
    }

    .total-score {
        border-top: 2px solid #e4e7ed;
        margin-top: 30px;
        padding-top: 20px;
    }

    .final-score {
        font-size: 20px;
        font-weight: bold;
        color: #409EFF;
        text-align: right;
        padding: 10px 0;
    }

    .refresh-container {
        margin: -10px 0 15px 0;
        padding-left: 10px;
        width: 70%;
    }
    
    .refresh-button {
        font-size: 12px;
    }

    .error-message {
        color: #F56C6C;
        font-size: 12px;
        margin-top: 5px;
        padding-left: 10px;
    }

    .is-required {
        border-color: #F56C6C;
    }

    /* 添加视频播放相关样式 */
    .video-dialog {
        ::v-deep .el-dialog__body {
            padding: 0;
        }
    }

    .video-container {
        width: 100%;
        background: #000;
        position: relative;
        padding-top: 56.25%; 
    }

    .video-player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    /* 移动端适配 */
    @media screen and (max-width: 768px) {
        .video-dialog {
            ::v-deep .el-dialog {
                margin: 0 !important;
                position: fixed;
                top: 0;
                left: 0;
                width: 100% !important;
                height: 100% !important;
                max-width: 100%;
                max-height: 100%;
                display: flex;
                flex-direction: column;
            }

            ::v-deep .el-dialog__header {
                padding: 10px;
                margin: 0;
                background: #fff;
                z-index: 1;
            }

            ::v-deep .el-dialog__title {
                font-size: 16px;
            }

            ::v-deep .el-dialog__headerbtn {
                top: 10px;
                right: 10px;
            }

            ::v-deep .el-dialog__body {
                flex: 1;
                overflow: hidden;
                padding: 0;
                margin: 0;
            }

            .video-container {
                height: 100%;
                padding-top: 0;
            }

            .video-player {
                position: relative;
                height: 100%;
            }
        }
    }

    /* 刷新按钮样式 */
    :deep(.refresh-button.el-button--primary) {
        background-color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }

    :deep(.refresh-button.el-button--primary:hover),
    :deep(.refresh-button.el-button--primary:focus) {
        background-color: #4BA89E !important;
        border-color: #4BA89E !important;
    }

    :deep(.refresh-button.el-button--primary:active) {
        background-color: #3E8F86 !important;
        border-color: #3E8F86 !important;
    }
</style>